import { ClearRounded } from '@mui/icons-material';
import {
  alpha,
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
  TextFieldProps,
  Theme,
} from '@mui/material';

import { SearchIcon } from '../../icons';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      paddingRight: '0px',
      paddingLeft: '0px',
      '&.MuiInputBase-multiline': {
        '& .MuiInputBase-input': {
          padding: '6px 12px',
          height: '32px',
          borderRadius: '8px',
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme: Theme) => `1px solid ${theme.palette.secondary.light}`,
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
          boxShadow: (theme: Theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.1)}`,
          outline: 'none',
        },
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: (theme: Theme) => theme.palette.primary.main,
        },
      },
      '& .MuiInputBase-input': {
        padding: '0px',
        height: '32px',
      },
      '&.Mui-disabled': {
        backgroundColor: '#F3F5F9',
      },
    },
  },
  searchIcon: {
    width: '12px',
    height: '12px',
    margin: '0 0 0 14px',
  },
};

export function SearchBar(props: TextFieldProps) {
  return (
    <TextField
      {...props}
      autoComplete='off'
      sx={{ ...customStyles.root, ...props.sx } as SxProps<Theme>}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon sx={customStyles.searchIcon} />
          </InputAdornment>
        ),
        endAdornment: props.value && (
          <InputAdornment position='end'>
            <IconButton
              onClick={() =>
                props.onChange?.({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)
              }
              size='small'
            >
              <ClearRounded fontSize='inherit' />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
